/**
 * Copyright © 2025 Delicious AI, LLC
 *
 */

import { gql } from '@apollo/client'

export const GET_ACTION_SHIFTS = gql`
  query GetTenantActionShifts {
    tenantActionShifts {
      title
      id
    }
  }
`
